<template>

  <div class="">
    <!-- aboutus intro -->
    <section class="aboutusIntro">
      <b-container fluid>
        <b-row class="intro-section justify-content-around">
          <b-col xl="6" lg="12" md="12" style="display: flex; align-items: right; margin-left: auto;">
            <div class="text-section">
              <div>
                <h1 class="mb-3"><b>الشروط والاحكــام</b></h1>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <!-- Terms and Conditions -->
    <section class="terms-conditions">
      <b-container fluid>
        <b-row class="justify-content-around"  style="text-align: right;">
          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">عن تخطي:</span>
              </div>
                <p>تخطي هي منصة إلكترونية مخصصة لتقديم جلسات نفسية وأسرية تهدف إلى تعزيز الصحة النفسية للأفراد والأسر والمجتمعات. تسعى المنصة إلى مساعدة المستخدمين في تجاوز الضغوط النفسية وتحسين مزاجهم من خلال خدمات الرعاية النفسية عن بُعد والطب الاتصالي. نحن نؤكد على التزامنا بحماية خصوصيتك واحترامها، وعند تسجيلك في تخطي، فإنك توافق على الشروط المذكورة في سياسة الخصوصية وغيرها من المتطلبات الموجودة على موقعنا.
                </p>
                <p>تحدد هذه السياسات الخاصة بنا في تخطي وغيرها من البنود المذكورة داخل التطبيق الأسس التي تحكم العلاقة بيننا وبين مقدم الخدمة "المختص" وبين مستفيد الخدمة "المستفيد". يُرجى ملاحظة أنه لا يمكنك تعديل أي بند أو إضافة شرط أو حذفه. كما نود أن نوضح أنه يحق لإدارة تخطي تعديل هذه الاتفاقية عند الحاجة دون الحاجة إلى موافقتك، وسيتم نشر التعديلات على التطبيق من خلال التحديثات المستمرة. يُعتبر استمرارك في استخدام تخطي والتواجد كمستخدم على الموقع التزامًا منك ودليلًا على رضاك وقبولك بالشروط والأحكام الواردة في النسخة المعدلة حديثًا</p>
            </div
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">حق الحصول على الخدمات:</span>
              </div>
              <p>أنت توافق وتتعهد بما يلي:</p>
              <p>لم يسبق لك أن تعرضت لتعطيل استخدام خدمات تخطي أو تم منعك من الوصول إليها في أي وقت. </p>
              <p>أي استخدام غير صحيح من جانبك كمستفيد خارج نطاق العلاقة المحددة سيؤدي إلى إيقاف حسابك فوراً.</p>
              <p>يجب أن تكون في سن 18 عاماً أو أكثر لتتمكن من الاستفادة من الخدمات في تطبيق تخطي.</p>
              <p>لا يتم صرف الأدوية عبر التطبيق لمن هم دون 18 عاماً، إلا بموافقة ولي الأمر.</p>
            </div>
          </b-col>
          
          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">الالتزامات والضمانات:</span>
              </div>
                <p>سوف تقوم بمراجعة والامتثال لأي إشعارات تُرسل عبر تطبيق تخطي بخصوص استخدامك للخدمة.</p>
                <p>لن يتم استخدام المعلومات أو المحتوى أو أي بيانات تحصل عليها من خلال خدمات تطبيق تخطي لأي غرض آخر سوى الاستخدام الشخصي. يجب عليك استخدام التطبيق والخدمة فقط لأغراضك الخاصة، ولن تقوم ببيعها لأي طرف ثالث.</p>
                <p>لن تؤثر على الأداء السليم لتطبيق تخطي.</p>
                <p>لن تسعى إلى إلحاق الأذى بالخدمة أو التطبيق بأي وسيلة.</p>
                <p>ستضمن الحفاظ على كلمة مرور حسابك أو أي وسيلة تعريف نقدمها لك، مما يتيح لك الوصول إلى حسابك بطريقة آمنة وسرية.</p>
                <p>لقد قمنا وسنستمر في بذل قصارى جهدنا لضمان عمل التطبيق بكفاءة وسهولة. ومع ذلك، فإن التطبيق لا يتحمل أي مسؤولية، ولن نكون مسؤولين عن أي مطالبات تتعلق بعدم توفر التطبيق مؤقتًا نتيجة لمشاكل فنية خارجة عن إرادتنا.</p>                
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">حقوق الملكية الفكرية:</span>
              </div>
              <p>تعود جميع حقوق الملكية الفكرية المتعلقة بهذه الخدمات وكل المواد المرتبطة بها أو التي تظهر في التطبيق إلى شركة تخطي الطبية، سواء كانت هذه الحقوق مسجلة أو غير مسجلة. تعتبر جميع معلومات المحتوى والتصميمات الموجودة في التطبيق ملكاً لنا، بما في ذلك على سبيل المثال لا الحصر: النصوص، الرسوم، البرمجيات، الصور، الفيديو، الموسيقى، الصوت، بالإضافة إلى اختيارها وتنسيقها، فضلاً عن جميع مصنفات البرمجيات ورموز المصدر والبرامج الأساسية.</p>
              <p>يجب عليك عدم السماح لأي شخص، مهما كانت الأسباب، باستخدام حسابك للحصول على جلسة أو الاستفادة من أي من خدمات شركة تخطي الطبية.</p>
            </div>
          </b-col>
          
          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">التكلفة:</span>
              </div>
              <p>تعتمد التكلفة المعروضة في تطبيق تخطي لكل خدمة قبل تقديم الطلب، وستكون متاحة في الصفحة الشخصية لكل مقدم خدمة "المختص". قد تختلف التكلفة بناءً على مقدم الخدمة "المختص" وفقًا للمعايير التي يحددها التطبيق. </p>
            </div>
          </b-col>

           <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">السداد:</span>
              </div>
              <P>يحتفظ تطبيق تخطي بالحق في تطبيق رسوم جديدة على استخدام التطبيق أو الخدمة أو كليهما.</P>
              <p>يجب عليك تسديد قيمة الخدمة "الجلسة" عبر تطبيق تخطي عند تحديد موعد مع المختص. </p>
              <p>تتوفر طرق الدفع المختلفة داخل المنصة مثل (مدى - أبل باي - فيزا ماستركارد - تابي - تمارا).</p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">سياسة الإلغاء والاسترداد:</span>
              </div>
              <p>يتم استرداد قيمة الجلسات للعميل في الحالات التالية:</p>
              <p>عند رغبة المستفيد في استرداد المبلغ المدفوع بالكامل، يجب أن يتم ذلك قبل 24 ساعة من موعد الجلسة.</p>
              <p>يحق للمستفيد استرداد المبلغ بالكامل في حال عدم حضور المختص للجلسة دون تقديم عذر مسبق.</p>
              <p>لا يحق للمستفيد استرداد أي مبلغ من الجلسة أو جزء منه في حال طلب إنهاء الجلسة خلال فترة الموعد.</p>
              <p>لا يمكن للمستفيد استرداد المبلغ بعد انتهاء الجلسة.</p>
              <p>في الحالات التي يتم فيها إعادة المبلغ إلى محفظة العميل، تكون مدة صلاحية الرصيد المسترد 90 يومًا.</p>
              <p>عند رغبة المستفيد في إلغاء مواعيد من باقة محجوزة بعد حضور جلسة واحدة أو أكثر دون إكمال باقي الجلسات، سيتم احتساب سعر الجلسة التي تم إكمالها بالسعر الأساسي دون أي خصم، وسيتم استرداد المبلغ المتبقي إلى محفظته.</p>
              <p>إذا أراد المستفيد إلغاء الجلسة قبل أكثر من 3 ساعات من موعدها، يمكنه استرداد 70% من المبلغ المدفوع في محفظته. </p>
              <p>أما إذا كان الإلغاء أقل من 3 ساعات من موعد الجلسة، فيمكنه استرداد 50% من المبلغ المدفوع.</p>
              <p>يرجى ملاحظة أن عملية استرداد المبلغ إلى وسائل الدفع المختلفة قد تستغرق من 7 إلى 10 أيام.</p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">الالتزامات القانونية:</span>
              </div>
              <p>
                المعلومات والتوصيات والخدمات المقدمة لك عبر موقع الويب أو تطبيق تخطي تهدف إلى تسهيل إتمام الخدمة وفقًا للطلب المقدم.
              </p>
              <p>
                سنسعى جاهدين للحفاظ على صحة وتحديث الموقع وتطبيق تخطي ومحتوياته، مع الأخذ بعين الاعتبار أهمية الجانب التطويري.
              </p>
              <p>
                لا يتحمل تطبيق تخطي أي مسؤولية عن الأضرار التي قد تنجم عن استخدامه أو عدم القدرة على استخدامه، بما في ذلك الأضرار الناتجة عن البرمجيات الضارة أو الفيروسات. كما أنه لا يتحمل مسؤولية عدم دقة أو عدم اكتمال المعلومات المتاحة على الموقع أو التطبيق.
              </p>
              <p>
                لا يتحمل تطبيق تخطي أي مسؤولية عن الأضرار التي قد تنجم عن قيام المستفيد بمشاركة معلومات الاتصال الخاصة به مع المختص.
              </p>
            </div>
          </b-col>

           <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">تعليق وتغيير وإيقاف الخدمات:</span>
              </div>
              <p>
                يحتفظ تطبيق تخطي بالحق الكامل، وبإرادته المنفردة ووفقًا لتقديره في تعديل أو تغيير الخدمة أو التطبيق أو تعليقهما أو إيقافهما (بما في ذلك، على سبيل المثال لا الحصر، أي ميزة أو قاعدة بيانات أو محتوى) في أي وقت، وذلك من خلال نشر إشعار على الموقع أو إرسال إشعار لك عبر الخدمة أو التطبيق أو عبر البريد الإلكتروني.
              </p>
            </div>
          </b-col>

           <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">تعديل شروط المستخدم:</span>
              </div>
              <p>
                يحتفظ تطبيق تخطي بالحق، وفقًا لتقديره الخاص، في تعديل أو استبدال أو تغيير أي من شروط المستخدم الحالية في أي وقت، دون الحاجة إلى إشعار أو تحمل أي مسؤولية.
              </p>
            </div>
          </b-col>

           <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">حدود المسئولية:</span>
              </div>
              <p>
                لا يقدم التطبيق أي ضمانات، سواء كانت صريحة أو ضمنية، بشأن الخدمات المقدمة، حيث يتم تقديمها "كما هي". نحن نسعى جاهدين لتوفير مستشارين ذوي كفاءة عالية لتلبية احتياجات المستفيدين وتقديم خدمات متميزة، ولكن لا يمكننا ضمان مدى استفادة العميل من الخدمة نظرًا لعدم قابليتها للقياس.
              </p>
            </div>
          </b-col>

           <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">الإشعار:</span>
              </div>
              <p>
                يمكن لتطبيق تخطي أن يقوم بإرسال إشعار من خلال إرسال إشعار عام يتعلق بالخدمة أو التطبيق، أو عبر إرسال بريد إلكتروني إلى عنوانك المسجل في معلومات حسابك لدى تخطي.
              </p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">القانون الساري وآليات تسوية المنازعات:</span>
              </div>
              <p>
 في حال نشوء أي نزاعات أو خلافات أو قضايا تتعلق بتفسير هذه الشروط والأحكام أو تنفيذها، فإنها تخضع لجميع شروط المستخدم المعمول بها وفقاً للقوانين والأنظمة السارية في جمهورية مصر العربية، وتفسر بناءً عليها.
              </p>
            </div>
          </b-col>
          
           <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">خطوات تعامل المختص مع الحالات الخطرة في حال حدوثها:</span>
              </div>
              <p>
                تقييم مستوى المخاطر من قبل المتخصص في الرعاية الصحية.
              </p>
              <p>
                يجب التأكد من وجود حالة ذات خطورة عالية قبل اتخاذ قرار الإبلاغ.
              </p>
              <p>
                يمكن السعي للتواصل مع المستفيد أو أحد أفراد أسرته أو أصدقائه من خلال الطلب المباشر منه، مع توضيح أهمية الحديث مع شخص قريب منه بطريقة آمنة.
              </p>
              <p>
                إذا تعذر التواصل مع أحد أقرباء المستفيد أو مع شخص قريب منه، وكانت الحالة تتطلب تدخلاً عاجلاً بناءً على تقييم المخاطر والعلامات المرتبطة، سيقوم المختص بتقديم بلاغ للجهات المعنية.
              </p>
              <p>
                بعد الحصول على رقم المستفيد، يجب الإبلاغ عن الحادث من خلال الاتصال بخدمات الطوارئ التابعة لوزارة الصحة وتقديم تفاصيل المحادثة وفقًا للمعلومات المتاحة.
              </p>
              <p>
                في حالات العنف الأسري أو إساءة معاملة الأطفال الذين تقل أعمارهم عن 18 عامًا، يُرجى الاتصال بمركز العنف الأسري لحماية حقوق الطفل.
              </p>
            </div>
          </b-col>

        </b-row>
      </b-container>
    </section>

        <!-- subscribe -->
    <section class="subscribe">
      <div>
        <div>
          <div class="">
            <div class="col-md-12 col-sm-12 col-xs-12"
              style="display: flex;align-items: center;justify-content: center;text-align: center;">
              <div class="py-5 my-5">
                <div class="">
                  <h2>تريد التعرف على كافة  خدمات تخطى والإشتراك بهم؟</h2>
                  <div class="description">
                    <br> 
                    <p v-if="!googleplay && !applestore" style="color: red;">
                      <b>التطبيق غير متاح حاليًا، لكنه سيكون متوفرًا قريبًا.</b>
                      <br>
                      <b-button @click="goToRoute('contactus')" class="px-4 py-2 my-4" variant="primary">
                      <span>تواصل معنا </span>
                      </b-button>
                    </p> 
                  </div>
                  <div v-if="googleplay || applestore" class="action-btns mt-2">
                    <b-button v-if="applestore" @click="goTowebsite(applestore)" class="px-4 py-3 mx-4 my-3"
                      style="background-color: black;color:white !important;border: black !important;">
                      <div class="carousel-btn-in-div px-3"
                        style="display: flex;align-items: center;justify-content: center;">
                        <div style="width: 35px;height:35px;color: white;" class="ml-3">
                          <img style="width: 35px;height: 40px;margin-top: -3px;"
                            src="../assets/images/Apple_logo_white.svg.png">
                        </div>
                        <div style="font-size: 14px;">
                          <span>متوفر على</span>
                          <br>
                          <span>App Store</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="px-4 py-3 mx-4 my-3"
                      variant="primary" style="color:white !important;border: black !important;">
                      <div class="carousel-btn-in-div px-3"
                        style="display: flex;align-items: center;justify-content: center;">
                        <div style="width: 40px;height: 40px;" class="carousel-btn-in-div-icon ml-3">
                          <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                            <path fill="none" d="M0,0h40v40H0V0z"></path>
                            <g>
                              <path
                                d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                                fill="#EA4335"></path>
                              <path
                                d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                                fill="#FBBC04"></path>
                              <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
                                fill="#4285F4"></path>
                              <path
                                d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                                fill="#34A853"></path>
                            </g>
                          </svg>
                        </div>
                        <div style="font-size: 14px;">
                          <span>متوفر على</span>
                          <br>
                          <span>Google Play</span>
                        </div>
                      </div>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import store from "../store/index.js"
import expertCarousel from "../components/ExpertCarousel.vue"
import { sendRequest } from '../utils/RequestHelper.js'

export default {
  name: 'Home',
  data() {
    return {
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      items: [],
    }
  },

  components: {
    expertCarousel
  },
  methods: {
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    goToContactus(name) {
      this.$router.push({
        name
      })
    },
    goToRoute(name, id) {
      this.$router.push({
        name,
        id
      });
    },
     loadData() {
      this.pageIsLoading = true;
      let body = {
        pageNumber: 1,
        pageSize: 999999
      }
      this.pageIsLoading = true;
      sendRequest('post', 'CourseAndEnrichment/CourseSearch',true , body,
        (response) => {
          this.items = response.data.data.items;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
          this.alertType = 'danger';
          this.alertText = 'Error loading data';
        }
      );
    }
  },
  created() {
    this.langDec = store.getters.getLangData
    this.loadData();
  }
}
</script>

<style scoped>

/* subscribe */
.subscribe {
  background-color: #f5f5f5;
}

.aboutusIntro .intro-section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../assets/images/privacyPolicy-terms.png);
  background-size: cover;
  background-position: center;
  width: auto;
  height: 450px !important;
  color: white;
}

.aboutusIntro .text-section {
  display: flex;
  align-items: center;
  margin-right: 70px !important;
}

.aboutusIntro .text-section h2 {

  font-size: 40px !important;
  font-weight: bolder !important;
  color: white;
}

.terms-conditions {
  padding: 80px 20px;
  text-align: right;
}

.terms-conditions .text-section {
  display: flex;
  align-items: center;
  padding: 0px 170px;
  width: 100% !important;
}

.terms-conditions .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.terms-conditions .text-section p {
  margin-top: 20px;
  font-size: 16px;
  color: #333;
}

@media (max-width: 991.98px) {
  .terms-conditions .text-section {
    padding: 0 30px;
  }
}

@media (max-width: 575.98px) {
  .terms-conditions .text-section {
    padding: 0 12px;
  }
}
</style>
